import { render, staticRenderFns } from "./Category-2.vue?vue&type=template&id=c6387646&"
import script from "./Category-2.vue?vue&type=script&lang=js&"
export * from "./Category-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports